import { createApp } from 'vue';
import OpusToFlacConverter from '@/Components/OpusToFlacConverter.vue';
import '@styles/app.css';

createApp(OpusToFlacConverter).mount('#opus-to-flac-converter');
